import React from 'react';

export const CheckmarkSvg = ({ color }: { color: string }) => {
  return (
    <svg fill="none" height="12" viewBox="0 0 14 12" width="12" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5.57031L5 9.57031L13 1.57031" stroke={color} strokeWidth="2.5" />
    </svg>
  );
};
